<template>
  <v-app id="login">
    <v-main>
      <v-layout id="LoginDiv"  v-resize="onResize" column style="padding-top: 56px">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-img
                :src="myImage"
                style="
                  max-width: 300px;
                  max-height: 300px;
                  margin-left: auto;
                  margin-right: auto;
                "
              ></v-img>
              <v-card class="elevation-12">
                <v-toolbar color="#FCC133" dark flat>
                  <v-toolbar-title>Login</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <!-- <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :href="source"
                        icon
                        large
                        target="_blank"
                        v-on="on"
                      >
                        <v-icon>mdi-code-tags</v-icon>
                      </v-btn>
                    </template>
                    <span>Source</span>
                  </v-tooltip> -->
                </v-toolbar>
                <v-form @submit.prevent="onSubmit()">
                  <v-card-text>
                    <v-text-field
                      label="Login (Username)"
                      name="login"
                      prepend-icon="mdi-account"
                      type="email"
                      v-model="username"
                    ></v-text-field>

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      v-model="password"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#FCC133" type="submit">Login</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    name: "Home",
    components: {},
    props: {
      source: String,
    },
    data() {
      return {
        myImage: require('../../public/img/login_taoyu.jpg'),
        // myImage: require('../../public/img/logo_daftar.png'),
        username: "",
        password: "",
        currentRouteName: "",
        randomNumber:'',
        security:false,
        isMobile: false,

      };
    },
    created() {
        this.currentRouteName = this.$route.name;
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else
            this.isMobile = false;
        },
        generateNumber: function () {
         this.randomNumber = parseInt(Math.random()*100000000).toString().substring(0,4); //multiply to generate random number between 0, 100
        } ,
        async InputSecurity(){
          const inputOptions = new Promise((resolve) => {
            setTimeout(() => {
              resolve({
                '#ff0000': 'Red',
                '#00ff00': 'Green',
                '#0000ff': 'Blue'
              })
            }, 1000)
          })
          this.generateNumber()
          await Swal.fire({
            title: 'Input Security Number',
            html:'<h1><b>'+this.randomNumber+'</></h1>',
            type:'input',
            input: 'number',
            //inputOptions: inputOptions,
            inputValidator: (value) => {
              if (value!==this.randomNumber) {
                this.security= false;
              }else{
                this.security= true;
              }
            }
          })

          return this.security;
        },
        onSubmit() {
            if (this.username.trim() && this.password.trim()) {
                let formData = new FormData();
                formData.append("name", this.username.trim());
                formData.append("password", this.password);

                const options = {
                url: "login",
                method: "post",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                data: formData
                };

                axios(options)
                .then(response => {
                  if(response.data.success){

                    const token = response.data.token;
                    if (token) {
                      this.$session.set('user_id', response.data.data.id);
                      this.$session.set('role', response.data.data.role);
                      this.$session.set('token', response.data.token);
                      // console.log('Token Login '+response.data.token);
                      // Vue.http.headers.common['Authorization'] = 'Bearer ' + response.body.token
                      this.InputSecurity().then((result) => {
                          if(result===true)
                          {
                            if(response.data.data.role==1){
                                console.log('Login as Admin');
                                this.$router.push({
                                    name: "Dash"
                                });
                                }else if(response.data.data.role==2){
                                    console.log('Login as Admin Tao Yu');
                                    this.$router.push({name: 'DTao'});
                                }else if(response.data.data.role==3){
                                    console.log('Login as Admin Huang Yi');
                                    this.$router.push({name: 'DHuang'});
                                }else if(response.data.data.role==4 || response.data.data.role==5){
                                    console.log('Login as User');
                                    //if(response.data.data.role==5){
                                        this.$router.push({name: 'UserRegis'});
                                    // }else {
                                    //     this.$router.push({name: 'UserRegis'});
                                    // }

                          }

                          }else{
                            Swal.fire({
                                title:'Peringatan',
                                icon :'warning',
                                text:'You Need to Input Right Number'
                            });

                          }
                      })
                      // if(this.InputSecurity()!==false)
                      // {
                      //   console.log(this.security)

                      // }






                    }




                  }else{
                   // alert(response.data.message);
                     Swal.fire({
                            title:'Peringatan',
                            icon :'warning',
                            text:response.data.message
                        });

                    console.log(response.data.role);
                  }
                })
                .catch(e => {
                       Swal.fire({
                            title:'Peringatan',
                            icon :'warning',
                            text:'Email / Password yang Dimasukkan Salah.'
                        });
                   //alert(e + "\n" + "");
                });
            }
        }
  }
}
</script>
<style>
#LoginDiv {
  background-color: red; /* For browsers that do not support gradients */
  background-image: linear-gradient(orange, yellow,white);
}
</style>
